import React from 'react';
import {Box, IconButton} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import PropTypes from "prop-types";

const FloatingAction = (props) => {
    // TODO: Implement plan functionality


    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: '30px',
                right: '30px',
                zIndex: '999',
                backgroundColor: 'primary.main',
                borderRadius: '50%',

            }}
        >
            <IconButton
                onClick={props.action}
                sx={{
                    padding: '10px',
                }}
            >
                <FeatherIcon icon="calendar" width="25" height="25" color='white'/>
            </IconButton>
        </Box>
    );
};

FloatingAction.propTypes = {
    action: PropTypes.func.isRequired,
};

export default FloatingAction;